module.exports = __webpack_public_path__ + "img/eSSpreparebox(2).536d70e3.jpg";